import { api } from "./api";
import { newIndication } from "./realization.service";
import { clearRegistrationUser } from "utils/fns";

export const salvarIniciativa = async (payload: any) => {
  try {
    const { data } = await api.post('database/bb_task__c', payload);
    return data;
  } catch (error) {
    console.error('Erro ao salvar iniciativa:', error);
    throw error;
  }
};

export const atualizarIniciativa = async (payload: any) => {
  try {
    const { data } = await api.put('database/bb_task__c', payload);
    return data;
  } catch (error) {
    console.error('Erro ao atualizar iniciativa:', error);
    throw error;
  }
};

// Manter compatibilidade com código existente
export const salvarIniciativaELBB = salvarIniciativa;

export const confirmarParticipacaoElbb = async (
  idRealizacao: string,
  player: string
): Promise<any> => {
  try {
    // Leitura via prepared aggregate: rawPlayer é derivado do player logado
    // (context.player) no servidor. id_realizacao continua param. Escritas inline.
    const { data } = await api.post('/find/insc_partic_premio_by_player_realizacao', {
      idRealizacao,
    });

    if (data && Array.isArray(data) && data.length > 0) {
      // Atualiza o registro existente (criado pelo bulk na inscrição do owner)
      return api.put('/database/insc_partic_premio__c', {
        _id: data[0]._id,
        dt_aceite: new Date(),
        id_realizacao: idRealizacao,
        id_inscricao: data[0].id_inscricao,
        rawPlayer: player,
        player,
        created: data[0].created,
      });
    }

    // Cria o registro caso não exista (fallback)
    return api.post('/database/insc_partic_premio__c', {
      player,
      id_realizacao: idRealizacao,
      dt_aceite: new Date(),
      rawPlayer: player,
    });
  } catch (error: any) {
    console.error('Erro ao confirmar participação ELBB:', error.message);
    throw error;
  }
};

export const inscricaoIniciativaElbb = async (
  body: any,
  iniciativaOriginal: any
): Promise<any> => {
  try {
    body['id_realizacao'] = iniciativaOriginal._id;

    let dataInscricao: any = null;
    const { data: inscricaoData } = await api.post('/find/inscricao_by_realizacao', {
      idRealizacao: iniciativaOriginal._id,
    });

    if (!Array.isArray(inscricaoData) || !inscricaoData.length) {
      const { data } = await api.post('/database/inscricao__c', body);
      if (!data) throw new Error('Falha ao criar inscrição');
      dataInscricao = data;
    } else {
      dataInscricao = inscricaoData[0];
    }

    // player usa rawPlayer (user._id raw) para consistência com team[i]._id
    await newIndication({
      player: body.rawPlayer,
      id_inscricao: dataInscricao._id,
      id_realizacao: iniciativaOriginal._id,
      dt_aceite: new Date(),
      rawPlayer: body.rawPlayer,
      concorrentes_info: [],
    });

    // Bulk para demais membros do time (exclui o player que fez a inscrição)
    const teamData = iniciativaOriginal.team || [];
    const inscricaoPlayerNormalized = clearRegistrationUser(body.rawPlayer || '');
    const bulkPayload = teamData
      .filter((item: any) => clearRegistrationUser(item._id || '') !== inscricaoPlayerNormalized)
      .map((item: any) => ({
        player: item._id,
        rawPlayer: item.chave || item._id,
        id_inscricao: dataInscricao._id,
        id_realizacao: iniciativaOriginal._id,
        concorrentes_info: [],
      }));

    if (bulkPayload.length > 0) {
      await api.post('/database/insc_partic_premio__c/bulk', bulkPayload);
    }

    return dataInscricao;
  } catch (error: any) {
    console.error('Erro ao criar inscrição ELBB:', error.message);
    throw error;
  }
};
